"use strict";

var _taggedTemplateLiteral = require("/Users/me/Work/PublicRec-main/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.conditionallyIncludePlugin = void 0;

var chalk_1 = __importDefault(require("chalk"));

var get_1 = __importDefault(require("lodash/get"));
/**
 *
 * @export
 * @param {string} id
 * @returns {string}
 */


function conditionallyIncludePlugin(_ref) {
  var resolve = _ref.resolve,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? '' : _ref$theme,
      _ref$requiredOptions = _ref.requiredOptions,
      requiredOptions = _ref$requiredOptions === void 0 ? [] : _ref$requiredOptions,
      _ref$previewable = _ref.previewable,
      previewable = _ref$previewable === void 0 ? true : _ref$previewable,
      _ref$enabled = _ref.enabled,
      isEnabled = _ref$enabled === void 0 ? true : _ref$enabled;
  var isPreviewEnvironment = process.env.PREVIEW === 'true';
  var missingOptions = requiredOptions.map(function (requiredOption) {
    return typeof requiredOption === 'string' ? [requiredOption, get_1.default(options, requiredOption)] : Object.entries(requiredOption)[0];
  }).filter(function (requiredOption) {
    return requiredOption[1] === undefined;
  }).map(function (requiredOption) {
    return requiredOption[0];
  }).join(', ');

  if (isEnabled && !missingOptions && (!isPreviewEnvironment || previewable)) {
    return [{
      options: options,
      resolve: resolve
    }];
  }

  var getTrueFalse = function getTrueFalse(value) {
    return value ? chalk_1.default(_templateObject || (_templateObject = _taggedTemplateLiteral(["{bold {green true}}"]))) : chalk_1.default(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["{bold {red false}}"])));
  };

  console.warn(chalk_1.default(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["{bold {magenta ", "}} not included:"])), resolve));
  console.warn(chalk_1.default(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["  {bold \u2022}\xA0theme: ", ""])), theme && chalk_1.default(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["{bold {cyan ", "}}"])), theme)));
  console.warn(chalk_1.default(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["  {bold \u2022}\xA0enabled: ", ""])), getTrueFalse(isEnabled)));
  console.warn(chalk_1.default(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["  {bold \u2022}\xA0missing option(s): {bold ", "}"])), missingOptions));
  console.warn(chalk_1.default(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["  {bold \u2022}\xA0can preview: ", ""])), getTrueFalse(previewable)));
  return [];
}

exports.conditionallyIncludePlugin = conditionallyIncludePlugin;